// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunner, Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import {
    AddressErrors,
    ResetFormErrors,
    ValidateEmail,
} from "@insite/client-framework/Store/CommonHandlers/ValidateAddress";
import {
    AddressFieldDisplayCollectionModel,
    BaseAddressModel,
    CustomerValidationDto,
} from "@insite/client-framework/Types/ApiModels";

type HandlerType = Handler<
    {
        address: BaseAddressModel;
        validationRules: CustomerValidationDto;
        addressFieldDisplayCollection: AddressFieldDisplayCollectionModel;
    } & HasOnSuccess<boolean>,
    {
        addressErrors: AddressErrors;
    }
>;

const customResetFormErrors: HandlerType = ResetFormErrors as any;

const customValidateEmail: HandlerType = ValidateEmail as any;

export const SetFormErrors: HandlerType = props => {
    props.dispatch({
        type: "CustomCheckoutShipping/SetBillToEmailAddressFormError",
        emailError: props.addressErrors.email,
    } as any);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(!props.addressErrors.email);
};

export const chain = [customResetFormErrors, customValidateEmail, SetFormErrors, ExecuteOnSuccessCallback];

const validateBillToEmailAddress = createHandlerChainRunner(chain, "ValidateBillToEmailAddress");
export default validateBillToEmailAddress;
